import * as sessionManager from '$domain/model/session/session.manager'

export const getRedirectPath = () => {
  return sessionManager.getRedirectPath()
}

export const saveRedirectPath = path => {
  return sessionManager.saveRedirectPath(path)
}



// WEBPACK FOOTER //
// ./src/services/session/redirectPath/redirectPath.service.ts